export const createAppStyles = (theme) => ({
  appContainer: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: theme.background,
    color: theme.text,
    minHeight: "100vh",
    transition: "background-color 0.3s ease, color 0.3s ease",
  },
  appHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: theme.headerBackground || theme.surface,
    borderBottom: `1px solid ${theme.border}`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
  },
  tabNavigation: {
    display: "flex",
    gap: "0.5rem",
  },
  tabButton: {
    padding: "0.5rem 1rem",
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    backgroundColor: theme.surface,
    color: theme.text,
    cursor: "pointer",
    transition: "all 0.2s",
    fontWeight: "500",
  },
  tabButtonActive: {
    backgroundColor: theme.primary,
    color: theme.surface,
    borderColor: theme.primary,
  },
  tabButtonHover: {
    backgroundColor: theme.background,
    borderColor: theme.primary,
  },
  authSection: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  userInfo: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    position: "relative",
  },
  userAvatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    border: `2px solid ${theme.primary}`,
  },
  username: {
    fontWeight: "500",
    color: theme.text,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  editButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "2px",
    borderRadius: "3px",
    color: theme.textSecondary,
    transition: "color 0.2s",
  },
  editButtonHover: {
    color: theme.primary,
    backgroundColor: theme.background,
  },
  usernameEditor: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  usernameInput: {
    padding: "4px 8px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    fontSize: "14px",
    width: "120px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  saveButton: {
    background: theme.success || "#10B981",
    color: "white",
    border: "none",
    borderRadius: "3px",
    padding: "4px 6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  cancelButton: {
    background: theme.error || "#EF4444",
    color: "white",
    border: "none",
    borderRadius: "3px",
    padding: "4px 6px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  themeButton: {
    padding: "0.5rem",
    backgroundColor: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  themeButtonHover: {
    backgroundColor: theme.background,
    borderColor: theme.primary,
  },
  tabContent: {
    flex: 1,
    backgroundColor: theme.background,
  },
  homePage: {
    padding: "2rem",
    backgroundColor: theme.background,
  },
  featureGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1.5rem",
    marginBottom: "2rem",
  },
  featureCard: {
    padding: "1.5rem",
    border: `1px solid ${theme.border}`,
    borderRadius: "0.5rem",
    backgroundColor: theme.cardBackground || theme.surface,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    color: theme.text,
    cursor: "pointer",
    transition: "all 0.3s ease",
    position: "relative",
  },
  loadingSpinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    fontSize: "1.2rem",
    color: theme.textSecondary,
    backgroundColor: theme.background,
  },
});

export const createSkillsStyles = (theme) => ({
  skillsCard: {
    backgroundColor: theme.surface,
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "24px",
    border: `2px solid ${theme.border}`,
    overflow: "hidden",
  },
  skillsTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    margin: "0",
    padding: "20px 20px 0 20px",
    textAlign: "center",
  },
  skillsTable: {
    width: "100%",
    borderCollapse: "collapse",
  },
  skillsHeaderRow: {
    backgroundColor: theme.background,
  },
  skillsHeaderCell: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    userSelect: "none",
  },
  skillsHeaderCellLast: {
    padding: "12px 16px",
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    color: theme.textSecondary,
    textTransform: "uppercase",
    borderBottom: `2px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
    userSelect: "none",
  },
  skillsHeaderCellHover: {
    backgroundColor: theme.primary + "10",
    color: theme.primary,
  },
  skillsHeaderCellActive: {
    backgroundColor: theme.primary + "20",
    color: theme.primary,
  },
  sortableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "4px",
  },
  skillRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  skillRowHover: {
    backgroundColor: theme.background,
  },
  skillCell: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
  },
  skillCellLast: {
    padding: "12px 16px",
    fontSize: "14px",
    color: theme.text,
    textAlign: "center",
  },
  proficiencyCircle: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: `2px solid ${theme.textSecondary}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  proficiencyCircleFilled: {
    backgroundColor: theme.text,
    borderColor: theme.text,
  },
  abilityMod: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  skillNameButton: {
    background: "none",
    border: "none",
    color: theme.text,
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    padding: "0",
    textAlign: "left",
    transition: "color 0.2s ease",
  },
  skillNameButtonProficient: {
    fontWeight: "600",
    color: theme.primary,
  },
  skillNameButtonHover: {
    color: theme.primary,
  },
  bonusValue: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
});

export const createCharacterCreationStyles = (theme) => ({
  container: {
    padding: "20px",

    margin: "0 auto",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    backgroundColor: theme.surface,
    padding: "25px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginBottom: "20px",
  },
  title: {
    margin: 0,
    fontSize: "2.5rem",
    color: theme.text,
    textShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  },
  subtitle: {
    fontSize: "18px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  userAvatarContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginTop: "12px",
  },
  userAvatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    border: `2px solid ${theme.primary}`,
  },
  welcomeText: {
    fontSize: "18px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  authContainer: {
    textAlign: "center",
    padding: "40px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
  },
  authHeader: {
    color: theme.text,
    marginBottom: "16px",
  },
  authText: {
    color: theme.textSecondary,
  },
  errorContainer: {
    backgroundColor: "#fee2e2",
    border: "1px solid #fecaca",
    color: "#dc2626",
    padding: "12px",
    borderRadius: "8px",
    margin: "16px 0",
    fontSize: "14px",
  },
  tabContainer: {
    display: "flex",
    gap: "8px",
    marginBottom: "20px",
    borderBottom: `2px solid ${theme.border}`,
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 20px",
    backgroundColor: theme.background,
    border: "none",
    borderRadius: "8px 8px 0 0",
    fontSize: "16px",
    fontWeight: "500",
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginBottom: "-2px",
  },
  activeTab: {
    backgroundColor: theme.surface,
    color: theme.text,
    borderBottom: `2px solid ${theme.primary}`,
  },
  tabContent: {
    backgroundColor: theme.background,
  },
  panel: {
    backgroundColor: theme.surface,
    padding: "25px",
    borderRadius: "12px",
    border: `2px solid ${theme.border}`,
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "20px",
    borderBottom: `2px solid ${theme.border}`,
    paddingBottom: "12px",
  },
  fieldContainer: {
    marginBottom: "20px",
  },
  label: {
    display: "block",
    fontWeight: "bold",
    marginBottom: "5px",
    color: theme.text,
    fontSize: "16px",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },
  select: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "8px",
    fontStyle: "italic",
  },
  button: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "white",
  },
  saveButton: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 32px",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    justifyContent: "center",
    marginTop: "20px",
    color: "white",
  },
  newCharacterButton: {
    backgroundColor: theme.success || "#10B981",
    color: "white",
    border: "none",
    padding: "12px 24px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
  },
  createNewButtonInSaved: {
    backgroundColor: theme.primary,
    color: "white",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
  },
  savedCharactersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  charactersContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "20px",
  },
  characterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "12px",
  },
  characterName: {
    fontSize: "20px",
    fontWeight: "bold",
    alignSelf: "center",
    color: theme.text,
    marginBottom: "8px",
  },
  characterInfo: {
    display: "flex",
    justifyContent: "center",
  },
  characterDetails: {
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
  },
  characterActions: {
    display: "flex",
    gap: "8px",
  },
  heritage: {
    color: theme.primary,
    fontWeight: "500",
    marginBottom: "4px",
  },
  feats: {
    fontSize: "13px",
    color: theme.textSecondary,
    marginTop: "8px",
    paddingTop: "8px",
    borderTop: `1px solid ${theme.border}`,
  },
  skills: {
    fontSize: "13px",
    color: theme.textSecondary,
    marginTop: "8px",
  },
  emptyCharacters: {
    textAlign: "center",
    padding: "40px",
    color: theme.textSecondary,
    fontSize: "18px",
    backgroundColor: theme.background,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  characterLimitWarning: {
    backgroundColor: "#fef3c7",
    border: "1px solid #f59e0b",
    color: "#92400e",
    padding: "16px",
    borderRadius: "8px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    marginTop: "20px",
  },
  characterLimitWarningText: {
    fontSize: "14px",
    fontWeight: "400",
    marginTop: "8px",
  },

  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  skillsPlaceholder: {
    padding: "20px",
    backgroundColor: theme.background,
    border: `2px dashed ${theme.border}`,
    borderRadius: "8px",
    textAlign: "center",
    color: theme.textSecondary,
    fontSize: "14px",
    fontStyle: "italic",
  },
  skillsContainer: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
  },
  skillsSubheader: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "12px",
    margin: "0 0 12px 0",
  },
  skillsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "12px",
    marginBottom: "12px",
  },
  skillOptionBase: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px",
    borderRadius: "8px",
    transition: "all 0.2s ease",
  },
  skillCheckbox: {
    width: "16px",
    height: "16px",
    accentColor: theme.success,
  },
  skillsComplete: {
    backgroundColor: theme.success + "20",
    color: theme.success,
    padding: "12px",
    borderRadius: "6px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "600",
    marginTop: "12px",
  },

  level1ChoiceContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
    marginTop: "12px",
  },
  level1ChoiceLabel: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  level1ChoiceLabelSelected: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.primary + "20",
    border: `2px solid ${theme.primary}`,
    borderRadius: "12px",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  level1ChoiceRadio: {
    width: "18px",
    height: "18px",
    accentColor: theme.primary,
  },
  level1ChoiceText: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
  },
  level1ChoiceTextSelected: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.primary,
  },

  asiChoiceContainer: {
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "20px",
    backgroundColor: theme.surface,
    marginBottom: "20px",
  },
  asiChoiceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "16px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${theme.border}`,
  },
  asiStatusBadgeComplete: {
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: `${theme.success}20`,
    color: theme.success,
    border: `1px solid ${theme.success}`,
  },
  asiStatusBadgeIncomplete: {
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "12px",
    fontWeight: "600",
    backgroundColor: `${theme.warning}20`,
    color: theme.warning,
    border: `1px solid ${theme.warning}`,
  },
  asiChoiceTypeGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    marginBottom: "20px",
  },
  asiChoiceTypeOption: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    border: `2px solid`,
  },
  asiChoiceTypeSelected: {
    borderColor: theme.primary,
    backgroundColor: `${theme.primary}10`,
  },
  asiChoiceTypeDefault: {
    borderColor: theme.border,
    backgroundColor: theme.background,
  },
  asiChoiceRadio: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
  },
  asiChoiceTitle: {
    fontSize: "16px",
    fontWeight: "600",
    marginBottom: "4px",
  },
  asiChoiceSubtitle: {
    fontSize: "12px",
    color: theme.textSecondary,
  },
  statusIndicatorComplete: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: theme.success,
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
  },
  noSelectionState: {
    border: `2px dashed ${theme.border}`,
    borderRadius: "8px",
    padding: "32px",
    textAlign: "center",
    backgroundColor: theme.background,
  },
  emptyStateSubtitle: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  completionMessage: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "12px",
    fontSize: "16px",
    fontWeight: "600",
    color: theme.success,
  },
  warningBadge: {
    padding: "4px 8px",
    backgroundColor: `${theme.warning}20`,
    color: theme.warning,
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "600",
    textTransform: "uppercase",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  featSelectionContainer: {
    background: theme.surface,
    border: `1px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
    marginTop: "8px",
  },
  featSearchContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featSearchInput: {
    width: "100%",
    padding: "12px 16px",
    paddingRight: "44px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    outline: "none",
    transition: "all 0.2s ease",
    boxSizing: "border-box",
    fontFamily: "inherit",
  },
  featSearchClearButton: {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    fontSize: "18px",
    color: theme.textSecondary,
    cursor: "pointer",
    padding: "4px 8px",
    borderRadius: "4px",
    transition: "color 0.2s ease",
  },
  featList: {
    maxHeight: "800px",
    overflowY: "auto",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.background,
  },
  featListItem: {
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: "transparent",
    transition: "background-color 0.2s ease",
  },
  featListItemSelected: {
    backgroundColor: `${theme.primary}10`,
  },
  featItemContent: {
    display: "flex",
    alignItems: "flex-start",
    padding: "12px 16px",
    gap: "12px",
  },
  featRadioButton: {
    marginTop: "2px",
    width: "16px",
    height: "16px",
    cursor: "pointer",
  },
  featContentArea: {
    flex: 1,
    minWidth: 0,
  },
  featTitle: {
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    flex: 1,
    transition: "color 0.2s ease",
  },
  featTitleSelected: {
    color: theme.primary,
  },
  featTitleDefault: {
    color: theme.text,
  },
  featPreviewDefault: {
    color: theme.textSecondary,
  },
  levelHpGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",
    alignItems: "end",
    marginBottom: "20px",
  },
  levelContainer: {
    display: "flex",
    flexDirection: "column",
  },
  hpFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  hpValueContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "44px",
  },
  hpDisplay: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    textAlign: "center",
    padding: "10px",
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    minWidth: "60px",
  },
  hpRollDisplay: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#10B981",
    textAlign: "center",
    padding: "10px",
    backgroundColor: `#10B981${"20"}`,
    border: "2px solid #10B981",
    borderRadius: "6px",
    minWidth: "60px",
  },
  hpManualInput: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
    width: "100%",
    padding: "10px",
    border: `2px solid ${theme.primary}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  hpControlsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    minHeight: "44px",
  },
  hpControlsInline: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "center",
  },
  hpToggle: {
    position: "relative",
    width: "46px",
    height: "24px",
    borderRadius: "12px",
    border: "2px solid",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  hpToggleKnob: {
    position: "absolute",
    top: "2px",
    width: "18px",
    height: "18px",
    backgroundColor: "white",
    borderRadius: "50%",
    transition: "left 0.3s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
  },

  magicModifiersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginTop: "12px",
  },
  magicModifierItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  magicModifierLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  magicModifierInput: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "bold",
    width: "100%",
    padding: "8px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    transition: "border-color 0.2s ease",
  },

  editingWarning: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    backgroundColor: theme.warning + "10",
    border: `1px solid ${theme.warning}`,
    borderRadius: "8px",
    marginBottom: "24px",
    color: theme.warning,
  },
  lockedFieldHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  lockedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    backgroundColor: theme.error + "20",
    color: theme.error,
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
    marginLeft: "8px",
    width: "80px",
  },
  lockButton: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "6px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
    color: "white",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  lockedFieldInfo: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontStyle: "italic",
    marginBottom: "12px",
    padding: "8px 12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    fontWeight: 400,
  },
  lockedAbilityScores: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: "12px",
    padding: "16px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  lockedAbilityScore: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
  },
  abilityName: {
    fontSize: "13px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  abilityValue: {
    fontSize: "16px",
    color: theme.text,
    fontWeight: "600",
  },
  actionButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    marginTop: "32px",
    paddingTop: "24px",
    borderTop: `1px solid ${theme.border}`,
  },
  warningContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 16px",
    backgroundColor: theme.warning + "10",
    border: `1px solid ${theme.warning}`,
    borderRadius: "8px",
    marginBottom: "16px",
    color: theme.warning,
    fontSize: "14px",
  },

  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: "white",
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featItem: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    transition: "all 0.2s ease",
  },
  featItemSelected: {
    backgroundColor: "#F0FDF4",
    border: "2px solid #10B981",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  featName: {
    color: theme.text,
  },
  featNameSelected: {
    color: "#059669",
  },
  featCheckbox: {
    width: "16px",
    height: "16px",
    marginRight: "8px",
    accentColor: theme.primary,
  },
  featExpandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  featPreview: {
    fontSize: "14px",
    color: theme.textSecondary,
    lineHeight: "1.4",
    fontStyle: "italic",
  },
  featPreviewSelected: {
    fontSize: "14px",
    color: "#047857",
    lineHeight: "1.4",
    fontStyle: "italic",
  },
  featDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    backgroundColor: theme.surface,
    padding: "12px",
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  featDescriptionSelected: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },

  levelUpWizard: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  wizardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
  },
  wizardTitle: {
    flex: 1,
    textAlign: "center",
  },
  stepIndicator: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  wizardProgress: {
    display: "flex",
    justifyContent: "center",
    gap: "8px",
    padding: "16px",
    backgroundColor: theme.background,
    borderBottom: `1px solid ${theme.border}`,
  },
  progressStep: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "600",
    backgroundColor: theme.border,
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  progressStepActive: {
    backgroundColor: theme.primary,
    color: "white",
  },
  progressStepComplete: {
    backgroundColor: theme.success,
    color: "white",
  },
  wizardContent: {
    flex: 1,
    padding: "24px",
    overflowY: "auto",
    backgroundColor: theme.background,
  },
  levelUpStep: {
    maxWidth: "600px",
    margin: "0 auto",
  },
  stepHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "20px",
  },
  stepTitle: {
    margin: 0,
    fontSize: "24px",
    fontWeight: "600",
    color: theme.text,
  },
  stepContent: {
    fontSize: "16px",
    lineHeight: "1.6",
  },
  stepDescription: {
    color: theme.textSecondary,
    marginBottom: "24px",
  },
  hpChoiceContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
  },
  hpChoice: {
    padding: "16px",
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    textAlign: "center",
    transition: "all 0.2s ease",
  },
  choiceTitle: {
    margin: "0 0 8px 0",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  choiceDescription: {
    margin: "0 0 16px 0",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  rolledResult: {
    padding: "8px 12px",
    backgroundColor: theme.success + "20",
    color: theme.success,
    borderRadius: "6px",
    marginBottom: "12px",
    fontSize: "14px",
  },
  chosenReward: {
    padding: "16px",
    backgroundColor: theme.primary + "10",
    border: `1px solid ${theme.primary}`,
    borderRadius: "8px",
    color: theme.primary,
    textAlign: "center",
  },
  rewardDetail: {
    fontSize: "14px",
    opacity: 0.8,
  },
  asiContainer: {
    maxWidth: "500px",
    margin: "0 auto",
  },
  asiProgress: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "24px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
  },
  abilityGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  abilityAsiRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  abilityInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  abilityScoreInfo: {
    fontSize: "14px",
    color: theme.textSecondary,
  },
  abilityControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  asiButton: {
    width: "32px",
    height: "32px",
    border: "none",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: "600",
    color: "white",
    transition: "all 0.2s ease",
  },
  asiIncrement: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    minWidth: "24px",
    textAlign: "center",
  },
  levelUpSummary: {
    maxWidth: "500px",
    margin: "0 auto",
  },
  summaryTitle: {
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "24px",
  },
  summarySection: {
    marginBottom: "20px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
  },
  sectionTitle: {
    margin: "0 0 8px 0",
    fontSize: "16px",
    fontWeight: "600",
    color: theme.primary,
  },
  wizardActions: {
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderTop: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
  },
  subtabContainer: {
    display: "flex",
    gap: "4px",
    borderBottom: `1px solid ${theme.border}`,
    marginBottom: "24px",
    backgroundColor: theme.background,
  },
  subtab: {
    background: "transparent",
    border: "none",
    borderRadius: "8px 8px 0 0",
    padding: "12px 20px",
    fontSize: "14px",
    fontWeight: "500",
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderBottom: "2px solid transparent",
  },
  activeSubtab: {
    backgroundColor: theme.surface,
    color: theme.text,
    fontWeight: "600",
    borderBottom: `2px solid ${theme.primary}`,
  },
  subtabContent: {
    minHeight: "400px",
  },

  filtersContainer: {
    display: "flex",
    gap: "16px",
    marginBottom: "24px",
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    flexWrap: "wrap",
    alignItems: "center",
  },
  searchContainer: {
    flex: "1 1 300px",
    minWidth: "200px",
  },
  searchInput: {
    width: "100%",
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
  },
  filterContainer: {
    minWidth: "150px",
  },
  filterSelect: {
    padding: "8px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "6px",
    fontSize: "14px",
    backgroundColor: theme.background,
    color: theme.text,
    minWidth: "120px",
  },
  sortContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  sortLabel: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  sortButton: {
    padding: "6px 12px",
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    fontSize: "12px",
    backgroundColor: theme.background,
    color: theme.textSecondary,
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  sortButtonActive: {
    backgroundColor: theme.primary,
    color: "white",
    borderColor: theme.primary,
  },

  charactersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
    gap: "20px",
    marginBottom: "24px",
  },
  characterCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "20px",
    transition: "all 0.2s ease",
  },
  characterCardSelected: {
    borderColor: theme.primary,
    boxShadow: `0 0 0 2px ${theme.primary}20`,
  },
  characterCardHeader: {
    marginBottom: "16px",
  },
  characterCardTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "8px",
  },
  characterNameSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
  },
  characterCardName: {
    margin: 0,
    fontSize: "18px",
    fontWeight: "600",
    color: theme.text,
  },
  selectedBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    backgroundColor: theme.primary,
    color: "white",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
  },
  characterLevel: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontWeight: "500",
    padding: "4px 8px",
    backgroundColor: theme.background,
    borderRadius: "6px",
  },
  characterCardBody: {
    marginBottom: "16px",
  },
  characterInfoRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  characterInfoItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "14px",
    color: theme.textSecondary,
  },
  characterStats: {
    display: "flex",
    gap: "8px",
    marginTop: "12px",
    flexWrap: "wrap",
  },
  statBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    fontSize: "12px",
  },
  statLabel: {
    color: theme.textSecondary,
    fontWeight: "500",
  },
  statValue: {
    color: theme.text,
    fontWeight: "600",
  },
  heritageBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.warning + "20",
    color: theme.warning,
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },
  featsBadge: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: "4px 8px",
    backgroundColor: theme.secondary + "20",
    color: theme.secondary,
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
  },
  subclassInfo: {
    marginTop: "8px",
    fontSize: "13px",
  },
  subclassLabel: {
    color: theme.textSecondary,
    marginRight: "6px",
  },
  subclassValue: {
    color: theme.text,
    fontWeight: "500",
  },
  characterCardActions: {
    display: "flex",
    gap: "4px",
    justifyContent: "space-evenly",
  },
  actionButton: {
    alignItems: "center",
    margin: "4px",
    display: "flex",
    justifyContent: "space-around",
    gap: "4px",
    padding: "8px 12px",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100px",
  },
  editButton: {
    backgroundColor: theme.primary,
    color: "white",
  },
  levelUpButton: {
    backgroundColor: theme.success,
    color: "white",
  },
  deleteButton: {
    backgroundColor: theme.error,
    color: "white",
    display: "flex",
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    textAlign: "center",
  },
  emptyStateTitle: {
    margin: "16px 0 8px 0",
    fontSize: "20px",
    fontWeight: "600",
    color: theme.text,
  },
  emptyStateText: {
    margin: 0,
    fontSize: "14px",
    color: theme.textSecondary,
    maxWidth: "400px",
  },

  summaryContainer: {
    padding: "16px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.border}`,
    marginTop: "24px",
  },
  summaryStats: {
    display: "flex",
    gap: "24px",
    flexWrap: "wrap",
  },
  summaryItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  summaryLabel: {
    fontSize: "12px",
    color: theme.textSecondary,
    fontWeight: "500",
  },
  summaryValue: {
    fontSize: "16px",
    color: theme.text,
    fontWeight: "600",
  },
});

export const createAbilityScorePickerStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  abilityScoresHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  abilityScoresTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    margin: 0,
  },
  buttonGroup: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  button: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 16px",
    border: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    color: "white",
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginBottom: "12px",
    fontStyle: "italic",
  },
  availableStats: {
    backgroundColor: theme.background,
    border: `2px solid ${theme.border}`,
    borderRadius: "8px",
    padding: "16px",
    marginBottom: "16px",
  },
  availableStatsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  availableStatsLabel: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  availableStatsTotal: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.textSecondary,
  },
  completeIndicator: {
    color: theme.success || "#10B981",
    marginLeft: "8px",
  },
  statsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "8px",
  },
  statBadge: {
    backgroundColor: theme.primary + "20",
    color: theme.primary,
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "600",
    border: `1px solid ${theme.primary}`,
  },
  allAssignedText: {
    color: theme.success || "#10B981",
    fontWeight: "600",
    fontSize: "14px",
  },
  abilityGrid: {
    marginTop: "12px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "16px",
  },
  abilityCard: {
    backgroundColor: theme.surface,
    border: `2px solid ${theme.border}`,
    borderRadius: "12px",
    padding: "16px",
    textAlign: "center",
    transition: "all 0.2s ease",
  },
  abilityName: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
    textTransform: "capitalize",
  },
  abilityModifier: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.primary,
    marginBottom: "8px",
  },
  abilityModifierEmpty: {
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.textSecondary,
    marginBottom: "8px",
  },
  abilityScoreContainer: {
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  abilityScore: {
    fontSize: "24px",
    fontWeight: "bold",
    color: theme.text,
  },
  input: {
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
    width: "60px",
    padding: "4px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
  },
  assignSelect: {
    padding: "8px 12px",
    border: `2px solid ${theme.border}`,
    borderRadius: "6px",
    backgroundColor: theme.surface,
    color: theme.text,
    fontSize: "14px",
    width: "100%",
  },
  trashButton: {
    backgroundColor: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "4px",
    padding: "4px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
  },
});

export const createFeatStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: "white",
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.textSecondary,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabelClickable: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  expandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.textSecondary,
    transition: "all 0.2s ease",
  },
  noFeatsFound: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.textSecondary,
    fontSize: "16px",
    backgroundColor: theme.surface,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  helpText: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "12px",
    fontStyle: "italic",
  },

  levelHeader: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  levelHeaderSelected: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success,
  },
  featureContainer: {
    marginBottom: "16px",
  },
  singleFeature: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
  },
  singleFeatureSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}40`,
  },
  choiceContainer: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelectedOption: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "20",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  featureName: {
    fontSize: "13px",
    color: theme.primary,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureNameSelected: {
    fontSize: "13px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureDescription: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  featureDescriptionSelected: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  choiceLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "pointer",
  },
  choiceLabelDisabled: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "not-allowed",
  },
  radioButton: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  radioButtonDisabled: {
    marginTop: "2px",
    accentColor: theme.textSecondary,
    cursor: "not-allowed",
    width: "16px",
    height: "16px",
    opacity: 0.5,
  },
  choiceText: {
    flex: 1,
    minWidth: 0,
  },
  choiceTextDisabled: {
    flex: 1,
    minWidth: 0,
    opacity: 0.5,
  },
  expandedDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },
});

export const createBackgroundStyles = (theme) => ({
  fieldContainer: {
    marginBottom: "20px",
  },
  skillsHeader: {
    fontSize: "20px",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "8px",
    margin: 0,
  },
  featFilterContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  featFilterInput: {
    width: "100%",
    padding: "12px 40px 12px 16px",
    borderRadius: "8px",
    border: `2px solid ${theme.warning || "#F59E0B"}`,
    fontSize: "16px",
    backgroundColor: theme.surface,
    color: theme.text,
    boxShadow:
      "inset 0 2px 6px rgba(245,158,11,0.2), 0 2px 4px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
  },
  featFilterClearButton: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    backgroundColor: "#FBBF24",
    color: theme.text,
    border: "none",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    transition: "all 0.2s ease",
  },
  featFilterResults: {
    fontSize: "12px",
    color: theme.text,
    marginTop: "4px",
    fontStyle: "italic",
  },
  featsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  featHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "8px",
  },
  featLabelClickable: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "600",
  },
  expandButton: {
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "4px",
    padding: "4px 8px",
    cursor: "pointer",
    fontSize: "12px",
    color: theme.text,
    transition: "all 0.2s ease",
  },
  noFeatsFound: {
    textAlign: "center",
    padding: "40px 20px",
    color: theme.text,
    fontSize: "16px",
    backgroundColor: theme.background,
    borderRadius: "12px",
    border: `2px dashed ${theme.border}`,
  },
  helpText: {
    fontSize: "14px",
    color: theme.text,
    marginTop: "12px",
    fontStyle: "italic",
  },

  levelHeader: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
  },
  levelHeaderSelected: {
    margin: "0 0 12px 0",
    fontSize: "14px",
    fontWeight: "600",
    color: theme.success,
  },
  featureContainer: {
    marginBottom: "16px",
    backgroundColor: theme.surface,
  },
  singleFeature: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
  },
  singleFeatureSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}40`,
  },
  choiceContainer: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "6px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelected: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "10",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  choiceContainerSelectedOption: {
    marginBottom: "12px",
    padding: "12px",
    backgroundColor: theme.success + "20",
    borderRadius: "6px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
  },
  featureName: {
    fontSize: "13px",
    color: theme.primary,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureNameSelected: {
    fontSize: "13px",
    color: theme.success,
    display: "block",
    marginBottom: "4px",
    fontWeight: "600",
  },
  featureDescription: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  featureDescriptionSelected: {
    margin: 0,
    fontSize: "12px",
    color: theme.text,
    lineHeight: "1.4",
  },
  choiceLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "pointer",
  },
  choiceLabelDisabled: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "not-allowed",
  },
  radioButton: {
    marginTop: "2px",
    accentColor: theme.success,
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  radioButtonDisabled: {
    marginTop: "2px",
    accentColor: theme.textSecondary,
    cursor: "not-allowed",
    width: "16px",
    height: "16px",
    opacity: 0.5,
  },
  choiceText: {
    flex: 1,
    minWidth: 0,
  },
  choiceTextDisabled: {
    flex: 1,
    minWidth: 0,
    opacity: 0.5,
  },
  hoverDescriptionExpanded: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },
  hoverDescription: {
    marginTop: "12px",
    fontSize: "14px",
    color: theme.text,
    lineHeight: "1.5",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `1px solid ${theme.primary}`,
    boxShadow: `0 0 0 1px ${theme.primary}20`,
  },
  pill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    backgroundColor: theme.primary + "20",
    color: theme.primary,
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "600",
    textTransform: "uppercase",
    marginLeft: "8px",
    cursor: "help",
  },
  pillAbility: {
    opacity: 0.9,
  },
  pillModifier: {
    fontWeight: "bold",
  },
  abilityChange: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    padding: "1px 4px",
    borderRadius: "4px",
    fontSize: "9px",
  },
  availableElementsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    maxHeight: "800px",
    overflowY: "auto",
    padding: "4px",
  },
  completionMessage: {
    textAlign: "center",
    padding: "16px",
    backgroundColor: theme.success + "20",
    color: theme.success || "#10B981",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "14px",
    marginBottom: "16px",
    border: `1px solid ${theme.success || "#10B981"}40`,
  },
  featCard: {
    marginBottom: "16px",
    padding: "16px",
    backgroundColor: theme.background,
    borderRadius: "8px",
    border: `2px solid ${theme.border}`,
    transition: "all 0.2s ease",
    cursor: "pointer",
    boxShadow: `0 2px 4px ${theme.border}40`,
  },
  selectedElementCard: {
    marginBottom: "16px",
    padding: "16px",
    backgroundColor: theme.success + "10",
    borderRadius: "8px",
    border: `2px solid ${theme.success}`,
    transition: "all 0.2s ease",
    cursor: "pointer",
    boxShadow: `0 0 0 2px ${theme.success}20`,
  },
  featName: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "4px",
  },
  featNameSelected: {
    fontSize: "16px",
    fontWeight: "600",
    color: theme.success || "#10B981",
    marginBottom: "4px",
  },
  featPreview: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "8px",
    fontStyle: "italic",
    lineHeight: "1.4",
  },
  featPreviewSelected: {
    fontSize: "14px",
    color: theme.textSecondary,
    marginTop: "8px",
    fontStyle: "italic",
    lineHeight: "1.4",
  },
  featChoicesContainer: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: theme.background,
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
  },
  choiceSection: {
    marginBottom: "16px",
  },
  choiceSectionTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme.text,
    marginBottom: "8px",
  },
  choiceGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  featChoiceLabel: {
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    borderRadius: "6px",
    border: `1px solid ${theme.border}`,
    backgroundColor: theme.surface,
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "14px",
    color: theme.text,
  },
  availableElementsSection: {
    marginTop: "16px",
    marginBottom: "16px",
  },
  availableChoicesIndicator: {
    fontSize: "12px",
    fontWeight: "500",
    color: theme.textSecondary,
    padding: "2px 8px",
    backgroundColor: theme.background,
    borderRadius: "4px",
    border: `1px solid ${theme.border}`,
  },
  lockedFeature: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: theme.surface,
    borderRadius: "8px",
    border: `2px dashed ${theme.border}`,
    opacity: 0.7,
  },
  lockedContainer: {
    fontSize: "14px",
    color: theme.textSecondary,
    fontStyle: "italic",
    textAlign: "center",
    padding: "8px",
  },
});

export const createCharacterSheetStyles = (theme) => ({
  container: {
    padding: "1.5rem",
    backgroundColor: theme.background,
    minHeight: "100vh",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    transition: "background 0.3s ease",
  },
  characterSelector: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}30`,
  },
  selectorTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  selectContainer: {
    position: "relative",
    width: "100%",
  },
  select: {
    width: "100%",
    padding: "0.75rem",
    fontSize: "1rem",
    border: `2px solid ${theme.border}`,
    borderRadius: "0.5rem",
    backgroundColor: theme.surface,
    color: theme.text,
    cursor: "pointer",
    appearance: "none",
    background: `${
      theme.surface
    } url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='${encodeURIComponent(
      theme.textSecondary
    )}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e") no-repeat right 0.75rem center/16px 16px`,
  },
  loadingContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    border: `2px solid ${theme.border}`,
    color: theme.textSecondary,
  },
  errorContainer: {
    textAlign: "center",
    padding: "2rem",
    backgroundColor: theme.error + "20",
    borderRadius: "0.5rem",
    border: `2px solid ${theme.error}`,
    color: theme.error,
  },
  headerCard: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    marginBottom: "1.5rem",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}30`,
  },
  headerFlex: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "1rem",
  },
  avatar: {
    width: "4rem",
    height: "4rem",
    backgroundColor: theme.primary + "20",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `2px solid ${theme.primary}`,
  },
  characterName: {
    fontSize: "1.875rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "0.5rem",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
  },
  infoItem: {
    color: theme.text,
  },
  label: {
    fontWeight: "600",
    color: theme.textSecondary,
  },
  combatStats: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "1rem",
    marginTop: "1rem",
  },
  statCard: {
    textAlign: "center",
    padding: "0.75rem",
    borderRadius: "0.5rem",
    border: "1px solid",
    backgroundColor: theme.surface,
  },
  statCardRed: {
    backgroundColor: theme.error + "20",
    borderColor: theme.error + "60",
  },
  statCardBlue: {
    backgroundColor: theme.primary + "20",
    borderColor: theme.primary + "60",
  },
  statCardBrown: {
    backgroundColor: theme.success + "20",
    borderColor: theme.success + "60",
  },
  statCardPurple: {
    backgroundColor: theme.secondary + "20",
    borderColor: theme.secondary + "60",
  },
  statCardBrownHover: {
    backgroundColor: theme.success + "60",
    borderColor: theme.success + "100",
  },
  statValue: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    marginBottom: "0.25rem",
  },
  statValueRed: {
    color: theme.error,
  },
  statValueBlue: {
    color: theme.primary,
  },
  statValueBrown: {
    color: theme.success,
  },
  statValuePurple: {
    color: theme.secondary,
  },
  statLabel: {
    fontSize: "0.875rem",
  },
  statLabelRed: {
    color: theme.error,
  },
  statLabelBlue: {
    color: theme.primary,
  },
  statLabelBrown: {
    color: theme.success,
  },
  statLabelPurple: {
    color: theme.secondary,
  },
  abilityCard: {
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: `2px solid ${theme.primary}40`,
    marginBottom: "1.5rem",
  },
  abilityTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
  },
  abilityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
    gap: "1rem",
  },
  abilityItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.75rem",
    backgroundColor: theme.background,
    borderRadius: "0.5rem",
    textAlign: "center",
    border: `1px solid ${theme.border}`,
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  abilityName: {
    fontWeight: "500",
    marginBottom: "0.5rem",
    color: theme.textSecondary,
  },
  abilityModifier: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: theme.text,
  },
  abilityScore: {
    fontSize: "0.875rem",
    color: theme.textSecondary,
    marginTop: "0.25rem",
  },
  skillsCard: {
    maxWidth: "600px",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1.5rem",
    border: `2px solid ${theme.border}`,
    marginBottom: "1.5rem",
    height: "1200px",
  },
  skillsTitle: {
    fontSize: "1.25rem",
    fontWeight: "bold",
    color: theme.text,
    marginBottom: "1rem",
    textAlign: "center",
    letterSpacing: "0.1em",
  },
  skillsTable: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: theme.surface,
  },
  skillsHeaderRow: {
    backgroundColor: theme.background,
    borderBottom: `2px solid ${theme.border}`,
  },
  skillsHeaderCell: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    textAlign: "center",
    borderRight: `1px solid ${theme.border}`,
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellLast: {
    padding: "0.75rem 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    textAlign: "center",
    letterSpacing: "0.05em",
    cursor: "pointer",
    transition: "background-color 0.2s",
    userSelect: "none",
  },
  skillsHeaderCellHover: {
    backgroundColor: theme.primary + "20",
  },
  skillsHeaderCellActive: {
    backgroundColor: theme.primary + "30",
    color: theme.primary,
  },
  sortableHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.25rem",
  },
  skillRow: {
    borderBottom: `1px solid ${theme.border}`,
    transition: "background-color 0.2s",
  },
  skillRowHover: {
    backgroundColor: theme.background,
  },
  skillCell: {
    padding: "0.5rem",
    textAlign: "center",
    borderRight: `1px solid ${theme.border}`,
    verticalAlign: "middle",
  },
  skillCellLast: {
    padding: "0.5rem",
    textAlign: "center",
    verticalAlign: "middle",
  },
  proficiencyCircle: {
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: `2px solid ${theme.textSecondary}`,
    backgroundColor: "transparent",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "inline-block",
  },
  proficiencyCircleFilled: {
    backgroundColor: theme.text,
    borderColor: theme.text,
  },
  abilityMod: {
    fontSize: "0.75rem",
    fontWeight: "bold",
    color: theme.textSecondary,
    letterSpacing: "0.05em",
  },
  skillNameButton: {
    background: "none",
    border: "none",
    fontSize: "0.875rem",
    fontWeight: "500",
    color: theme.text,
    cursor: "pointer",
    padding: "0.25rem 0.5rem",
    borderRadius: "0.25rem",
    transition: "all 0.2s",
    textAlign: "left",
    width: "100%",
  },
  skillNameButtonProficient: {
    color: theme.primary,
    fontWeight: "600",
  },
  skillNameButtonHover: {
    backgroundColor: theme.background,
  },
  bonusValue: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    color: theme.text,
    backgroundColor: theme.background,
    border: `1px solid ${theme.border}`,
    borderRadius: "0.25rem",
    padding: "0.25rem 0.5rem",
    minWidth: "35px",
    display: "inline-block",
  },
  instructionsCard: {
    marginTop: "1.5rem",
    backgroundColor: theme.surface,
    borderRadius: "0.5rem",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
    padding: "1rem",
    border: `2px solid ${theme.border}`,
  },
  instructionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gap: "1rem",
    fontSize: "0.875rem",
    color: theme.textSecondary,
  },
  instructionItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  warning: {
    marginTop: "0.5rem",
    fontSize: "0.75rem",
    color: theme.warning,
  },
  inputGroup: {
    display: "flex",
    gap: "8px",
    marginBottom: "12px",
    alignItems: "center",
  },
});

export const getAllStyles = (theme) => ({
  app: createAppStyles(theme),
  skills: createSkillsStyles(theme),
  characterCreation: createCharacterCreationStyles(theme),
  abilityScorePicker: createAbilityScorePickerStyles(theme),
  feats: createFeatStyles(theme),
  backgrounds: createBackgroundStyles(theme),
  characterSheet: createCharacterSheetStyles(theme),
});

export {
  createAppStyles as createThemedStyles,
  createSkillsStyles as getSkillsStyles,
  createCharacterCreationStyles as getStyles,
  createAbilityScorePickerStyles as getAbilityScorePickerStyles,
  createFeatStyles as getFeatStyles,
  createBackgroundStyles as getBackgroundStyles,
  createCharacterSheetStyles as getCharacterSheetStyles,
};
